/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]     td.activity-log-suspension-bg{background-color:#fff1f2;color:#9f1239}[_nghost-%COMP%]     td.activity-log-suspension-bg span{color:#9f1239}[_nghost-%COMP%]     tr.changeOnHover:hover td.activity-log-suspension-bg{background-color:#ffe4e6}\n/*# sourceMappingURL=captain-activities.component.css.map*/"];
export { styles as styles };
